import InputButton from '../../reusable-components/buttons/input-button';
import StandardButton from '../../reusable-components/buttons/standard-button';
import './tutorial-screen.scss';

/**
 * This screen provides instructions on how to play the game and explains the available hints.
 * */
const TutorialScreen: React.FC = () => {

  return (
    <div className="tutorial-screen">
      <div className="how-to-play">
        <div className="tutorial-section">
            <div className="title">How to Play</div>
            <div className="body">
              <div className="step">
                <div className="number">1</div>
                Enter your word, and Word Player will pick a random mystery word to go with it
              </div>
              <div className="step">
                <div className="number">2</div>
                Word Player then searches youtube for "(Your Word) (Mystery Word)"
              </div>
              <div className="step">
                <div className="number">3</div>
                Watch the videos from the search results and try to figure out the mystery word!
              </div>
              <div className="step">
                You will also get to use the following actions in exchange for Hint Points:
              </div>
            </div>
        </div>
      </div>
      
      <div className="hint-tips">
        <div className="tutorial-section">
          <div className="title">Actions</div>
          <div className="body">
            <div className="grid-container">
              <div className="grid-item">
                <InputButton 
                  buttonText={`Guess Mystery Word`}
                  clickHandler={()=>{}}/>
              </div>
              <div className="grid-item">
                <InputButton 
                  buttonText={`Change Your Word`}
                  clickHandler={()=>{}}/>
              </div>
              <div className="grid-item">
                <div className="tip">This is where you enter your guesses. If you guess correctly you will recover Hint Points and advance to the next round.</div>
              </div>
              <div className="grid-item">
                <div className="tip">If you don't like the word you chose you can change it for some Hint Points. You will also have the option to change your word for free in between rounds.</div>
              </div>
              <div className="grid-item">
                <StandardButton 
                  buttonText={`Buy Next Video`}
                  clickHandler={()=>{}} />
              </div>
              <div className="grid-item">
                <StandardButton 
                  buttonText={`Reveal Random Letter`}
                  clickHandler={()=>{}} />
              </div>
              
              <div className="grid-item">
                <div className="tip">This unlocks the next video in the search results and plays it. This is the cheapest action so feel free to watch plenty of videos!</div>
              </div>
              <div className="grid-item">
                <div className="tip">This will reveal one of the letters in the mystery word. The price will be cheaper the longer the mystery word is, so you can reveal lots of letters on long mystery words!</div>
              </div>
              <div className="full-row-item">
                <StandardButton 
                  buttonText={`New Mystery Word`} 
                  clickHandler={()=>{}} />
              </div>
              <div className="tip">If you're having trouble figuring out the mystery word you can always get a new one, but it will cost you half of your remaining Hint Points.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TutorialScreen;